import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { McpCredentialsResponse } from '@/modules/api/get/mcpCredentials'

// POST /ajax/account_settings/mcp
export const generateMcpCredentials = async (): Promise<McpCredentialsResponse> => {
  const response = await new Request().post('/ajax/account_settings/mcp', {})
  return Util.Obj.keysToCamel(response.data) as McpCredentialsResponse
}

// POST /ajax/account_settings/mcp/regenerate
export const regenerateMcpCredentials = async (): Promise<McpCredentialsResponse> => {
  const response = await new Request().post('/ajax/account_settings/mcp/regenerate', {})
  return Util.Obj.keysToCamel(response.data) as McpCredentialsResponse
}
